var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "57px",
    viewBox: "0 0 43 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4D07BAEC-2AB1-4A7E-B457-E8EC35BC7594") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "procurement/plan/details/contract-signing/contract-unsigned--view",
    transform: "translate(-1299.000000, -429.000000)",
    stroke: "#58595B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(252.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(20.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal",
    transform: "translate(1028.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.461538, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "32.8280543 42.6421405 32.8280543 48.9130435 26.6063348 48.9130435 20.3846154 56.4381271 14.1628959 48.9130435 7.94117647 48.9130435 7.94117647 42.6421405 0.475113122 36.3712375 7.94117647 30.1003344 7.94117647 23.8294314 14.1628959 23.8294314 20.3846154 16.3043478 26.6063348 23.8294314 32.8280543 23.8294314 32.8280543 30.1003344 40.2941176 36.3712375"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10.4298643 1.2541806 10.4298643 11.2876254 20.3846154 16.3043478 30.3393665 11.2876254 30.3393665 1.2541806"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.9638009,
    y1: 1.2541806,
    x2: 37.8054299,
    y2: 1.2541806,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4072398,
    y1: 1.2541806,
    x2: 15.4072398,
    y2: 13.7959866,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.361991,
    y1: 1.2541806,
    x2: 25.361991,
    y2: 13.7959866,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "27.8506787 40.7608696 20.3846154 45.1505017 12.918552 40.7608696 12.918552 31.9816054 20.3846154 27.5919732 27.8506787 31.9816054"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractLogo);
export default __webpack_public_path__ + "static/media/contract_logo.c13ee1a6.svg";
export { ForwardRef as ReactComponent };